

export default class Lien {

    points=[]
    from='' //La tache
    fromExact='' // la sortie exacte de cette tache
    to='' // la tache cible
    type='NORMAL'  // sert a rien pour l'instant
    data={
        label:"LIEN",
        ref:'',
        color:'#CCCCCC',
        decale:0
    }

    constructor(from,fromE,to) {
        this.from=from
        this.fromExact=fromE
        this.to=to
        this.data.ref="L"+Date.now()+1
    }


}